import React from "react"

import ServiceSection from "./ServiceSection"
import ServiceSectionBox from "./ServiceSectionBox/index";
import Style from "./ServiceSectionsList.module.sass";

export default function ServiceSectionsList(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { sections, onShowModal, orderingEnabled, flatList, onSectionBoxPress } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  const renderFlatList = () => {
    return <div className={"service-sections-list"}>
      {sections.map((section) => {
        const {
          id,
          title,
          description,
          services,
          service_section_part_configs,
        } = section

        return (
          <ServiceSection
            key={id}
            sectionId={id}
            title={title}
            description={description}
            services={services}
            serviceSectionPartConfigs={service_section_part_configs}
            orderingEnabled={orderingEnabled}
            onShowModal={onShowModal}
          />
        )
      })}
    </div>
  }

  const renderBoxList = () => {
    return <div>
      <h3 className={Style.title}>Cerca per categoria</h3>

      <div className="row">
        {sections.map((section) => <ServiceSectionBox onClick={onSectionBoxPress}
                                                      key={section.id}
                                                      section={section}/>)
        }

      </div>
    </div>
  }

  return (flatList ? renderFlatList() : renderBoxList()
  )
}
